import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import AppNav from "@/components/AppNav";
import AppFooter from "@/components/AppFooter";
import ProtectedRoute from "@/components/ProtectedRoute";
import GateGuard from "@/components/GateGuard";

import HowItWorks from "@/pages/HowItWorks";
import RequestInvite from "@/pages/RequestInvite";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Browse from "@/pages/Browse";
import ListingDetail from "@/pages/ListingDetail";
import Sell from "@/pages/Sell";
import BulkUpload from "@/pages/BulkUpload";
import PsaPhotos from "@/pages/PsaPhotos";
import MyListings from "@/pages/MyListings";
import Messages from "@/pages/Messages";
import Conversation from "@/pages/Conversation";
import Watchlist from "@/pages/Watchlist";
import NeedleFound from "@/pages/NeedleFound";
import ContestTerms from "@/pages/ContestTerms";
import ForgotPassword from "@/pages/ForgotPassword";
import Account from "@/pages/Account";
import MyAd from "@/pages/MyAd";
import AdInquiry from "@/pages/AdInquiry";
import Transactions from "@/pages/Transactions";
import Cart from "@/pages/Cart";
import Offers from "@/pages/Offers";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import PublicProfile from "@/pages/PublicProfile";
import Terms from "@/pages/Static";
import FAQ from "@/pages/FAQ";
import HowTo from "@/pages/HowTo";
import Contact from "@/pages/Contact";
import TrustSafety from "@/pages/TrustSafety";
import VendorHandbook from "@/pages/VendorHandbook";
import Changelog from "@/pages/Changelog";
import Roadmap from "@/pages/Roadmap";
import About from "@/pages/About";
import Contest from "@/pages/Contest";

function App() {
  return (
    <div className="App min-h-screen text-white font-body pb-16 md:pb-0">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
          <Toaster theme="dark" position="bottom-right" richColors closeButton offset="24px" mobileOffset={{ bottom: "80px", right: "12px", left: "12px" }} />
          <GateGuard>
            <AppNav />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/request-invite" element={<RequestInvite />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />

              <Route path="/browse" element={<ProtectedRoute><Browse /></ProtectedRoute>} />
              <Route path="/listing/:id" element={<ProtectedRoute><ListingDetail /></ProtectedRoute>} />
              <Route path="/sell" element={<ProtectedRoute><Sell /></ProtectedRoute>} />
              <Route path="/sell/bulk" element={<ProtectedRoute><BulkUpload /></ProtectedRoute>} />
              <Route path="/sell/bulk/photos" element={<ProtectedRoute><PsaPhotos /></ProtectedRoute>} />
              <Route path="/listing/:id/edit" element={<ProtectedRoute><Sell /></ProtectedRoute>} />
              <Route path="/my-listings" element={<ProtectedRoute><MyListings /></ProtectedRoute>} />
              <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
              <Route path="/messages/:convoId" element={<ProtectedRoute><Conversation /></ProtectedRoute>} />
              <Route path="/watchlist" element={<ProtectedRoute><Watchlist /></ProtectedRoute>} />
              <Route path="/contests/needle-found" element={<ProtectedRoute><NeedleFound /></ProtectedRoute>} />
              <Route path="/contests/terms" element={<ContestTerms />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ForgotPassword />} />
              <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
              <Route path="/my-ad" element={<ProtectedRoute><MyAd /></ProtectedRoute>} />
              <Route path="/ad-inquiry" element={<ProtectedRoute><AdInquiry /></ProtectedRoute>} />
              <Route path="/transactions" element={<ProtectedRoute><Transactions /></ProtectedRoute>} />
              <Route path="/cart" element={<ProtectedRoute><Cart /></ProtectedRoute>} />
              <Route path="/offers" element={<ProtectedRoute><Offers /></ProtectedRoute>} />
              <Route path="/u/:username" element={<ProtectedRoute><PublicProfile /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />

              <Route path="/terms" element={<Terms which="terms" />} />
              <Route path="/privacy" element={<Terms which="privacy" />} />
              <Route path="/guidelines" element={<Terms which="guidelines" />} />

              <Route path="/faq" element={<FAQ />} />
              <Route path="/how-to" element={<HowTo />} />
              <Route path="/contact" element={<ProtectedRoute><Contact /></ProtectedRoute>} />
              <Route path="/trust-safety" element={<TrustSafety />} />
              <Route path="/vendor-handbook" element={<VendorHandbook />} />
              <Route path="/changelog" element={<Changelog />} />
              <Route path="/roadmap" element={<Roadmap />} />
              <Route path="/about" element={<About />} />
              <Route path="/contest" element={<Contest />} />
            </Routes>
            <AppFooter />
          </GateGuard>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
